<template>
    <v-dialog v-model="cargar" :max-width="tamModal" :fullscreen="$root.isTouch" :scrollable="$root.isTouch == false" persistent>
        <v-card elevation="11">
            <v-card-title class="bg-title-card"> <span class="white--text headline" v-html="tituloFormulario"></span></v-card-title>
            <v-card-text>
                <v-form ref="form">
                    <v-container fluid grid-list-sm>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Contratante *" color="textbox" v-model="seleccionado.idContratante"
                                    :rules="requeridoRegla" :items="listaGeneral.contratante" item-text="contratante"
                                    item-value="idContratante" outlined dense />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Aseguradora *" color="textbox" v-model="seleccionado.idAseguradora"
                                    :rules="requeridoRegla" :items="listaGeneral.aseguradora" item-text="aseguradora"
                                    item-value="idAseguradora" outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Seguro *" color="textbox" v-model="seleccionado.idSeguro"
                                    :rules="requeridoRegla" :items="listaGeneral.seguro" item-text="seguro"
                                    item-value="idSeguro" @change="seguroSeleccionado" outlined dense />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field label="Naturaleza *" color="textbox" v-model="seleccionado.naturaleza"
                                    :rules="requeridoRegla" disabled outlined dense />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field label="Regulación" color="textbox" v-model="seleccionado.regulacion"
                                    :rules="requeridoRegla" disabled outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <span color="black" class="headline text-xs-center" v-text="'Datos Póliza'"></span>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Canal *" color="textbox" v-model="seleccionado.idCanal"
                                    :rules="requeridoRegla" :items="listaGeneral.canal" item-text="canal"
                                    item-value="idCanal" outlined dense />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Tipo Póliza *" color="textbox" v-model="seleccionado.idTipoPoliza"
                                    :rules="requeridoRegla" :items="listaTipoPoliza" item-text="tipoPoliza"
                                    item-value="idTipoPoliza" outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Numero Póliza *" color="textbox" v-model="seleccionado.poliza"
                                    :rules="_.concat(requeridoRegla,soloNumerosRegla(0,seleccionado.poliza,100))" outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Comisión *" color="textbox" v-model.number="seleccionado.porcComision"
                                    suffix="%" :rules="_.concat(requeridoRegla,numeroRegla)" outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Beneficios *" color="textbox"
                                    v-model.number="seleccionado.porcBeneficios" suffix="%"
                                    :rules="_.concat(requeridoRegla,numeroRegla)" outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Provincia *" color="textbox" v-model="seleccionado.idProvincia"
                                    :rules="requeridoRegla" :items="listaGeneral.provincias" @change="onListarCantones"
                                    outlined dense />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Canton *" color="textbox" v-model="seleccionado.idCanton"
                                    :rules="requeridoRegla" :items="listaGeneral.canton" item-text="canton"
                                    item-value="idCanton" outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" :sm="seleccionar ? 4 : 3" >
                                <v-checkbox class="justify-center" @change="polizaAbierta" color="primary"
                                    v-model="seleccionar" label="Poliza Abierta"></v-checkbox>
                            </v-col>
                            <v-col cols="6" :sm="seleccionar ? 4 : 3">
                                <v-dialog ref="dialogDesde" v-model="objDateDesde.abrirDialogo"
                                    :return-value.sync="fechaVigenciaDesdeDatePicker" persistent
                                    width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field label="Fecha Vigencia Desde *" color="textbox"
                                            v-model="seleccionado.fechaDesde" :rules="requeridoRegla"
                                            prepend-inner-icon="event" readonly outlined dense v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="seleccionado.fechaDesde" color="primary"
                                        :max="seleccionado.fechaHasta" scrollable locale="es">
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" @click="objDateDesde.abrirDialogo = false" rounded
                                            v-text="'Salir'"></v-btn>
                                        <v-btn color="primary" rounded
                                            @click="$refs.dialogDesde.save(fechaVigenciaDesdeDatePicker)"
                                            v-text="'Guardar Fecha'"></v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                            <v-col cols="6" sm="3" v-show="!seleccionar">
                                <v-dialog ref="dialogHasta" v-model="objDateHasta.abrirDialogo"
                                    :return-value.sync="fechaVigenciaHastaDatePicker" persistent
                                    width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field label="Fecha Vigencia Hasta *" color="textbox"
                                            v-model="seleccionado.fechaHasta" :rules="requeridoRegla"
                                            prepend-inner-icon="event" readonly outlined dense v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="seleccionado.fechaHasta" color="primary"
                                        :min="seleccionado.fechaDesde" scrollable locale="es">
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" @click="objDateHasta.abrirDialogo = false" rounded
                                            v-text="'Salir'"></v-btn>
                                        <v-btn color="primary" rounded
                                            @click="$refs.dialogHasta.save(fechaVigenciaHastaDatePicker)"
                                            v-text="'Guardar Fecha'"></v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                            <v-col cols="12" :sm="seleccionar ? 4 : 3">
                                <v-dialog ref="dialogEmision" v-model="objDateEmision.abrirDialogo"
                                    :return-value.sync="fechaEmisionDatePicker" persistent width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field label="Fecha Emisión *" color="textbox"
                                            v-model="seleccionado.fechaEmision" :rules="requeridoRegla"
                                            prepend-inner-icon="event" readonly outlined dense v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="seleccionado.fechaEmision" color="primary" :max="fechaActual"
                                        scrollable locale="es">
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" @click="objDateEmision.abrirDialogo = false"
                                            v-text="'Salir'"></v-btn>
                                        <v-btn color="primary"
                                            @click="$refs.dialogEmision.save(fechaEmisionDatePicker)"
                                            v-text="'Guardar Fecha'"></v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Broker *" color="textbox" v-model="seleccionado.idBroker"
                                    :rules="requeridoRegla" :items="listaGeneral.broker" item-text="broker"
                                    item-value="idBroker" outlined dense />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Estado *" color="textbox" v-model="seleccionado.idEstado"
                                    :rules="requeridoRegla" :items="listaEstado" item-text="nombre_estado"
                                    item-value="id_estado" outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-spacer/>
                            <v-col class="text-right">
                                <v-btn class="mr-1" outlined rounded color="danger" @click="cerrarFormulario(), $refs.form.resetValidation()">Cancelar</v-btn>
                                <v-btn rounded dark color="primary" @click="guardar()">Guardar</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import {format} from 'path';
    export default {
        data: () => ({
            objDateDesde: {
                abrirDialogo: false
            },
            objDateHasta: {
                abrirDialogo: false
            },
            objDateEmision: {
                abrirDialogo: false
            },
            date: new Date().toISOString().substr(0, 10),
            fechaActual: moment().format('YYYY-MM-DD'),
            fechaVigenciaDesdeDatePicker: moment().format('YYYY-MM-DD'),
            fechaVigenciaHastaDatePicker: moment().format('YYYY-MM-DD'),
            fechaEmisionDatePicker: false,
            seleccionar: true
        }),
        watch: {
            cargar: {
                immediate: true,
                handler(val,oldVal){
                    if (this.cargar && !_.isUndefined(this.seleccionado.idPoliza))
                        this.onListarCantones('l');
                    
                    this.seleccionar = this.listaGeneral.fechaHasta == moment(this.seleccionado.fechaHasta).format( 'YYYY-MM-DD') ? true : false;
                }
            }
        },
        methods: {
            onListarCantones(e) {
                if (!_.isUndefined(e)) {
                    var objeto = {
                        opcion: 'L',
                        idProvincia: this.seleccionado.idProvincia,
                        idEstado: '1'
                    };
                    return axios.post(`${BASE_URI}administrador/canton/listar`, objeto)
                        .then((respuesta) => {
                            if (respuesta.status != 200 && respuesta.statusText != 'OK') throw mensajeEstandar
                                .errorPeticion;
                            if (respuesta.data.existeError) throw respuesta.data.mensaje;
                            if (_.size(respuesta.data.data) > 0)
                                this.$set(this.listaGeneral, 'canton', respuesta.data.data);
                            else
                                mensajesAlerta(respuesta.data.mensaje, 'I');
                        })
                        .catch((e) => {
                            mensajesAlerta(!_.isUndefined(e) ? e : mensajeEstandar.errorPeticion, 'E');
                        })
                }
            },
            polizaAbierta() {
                if (this.seleccionar) {
                    this.seleccionado.fechaHasta = this.listaGeneral.fechaHasta;
                }
            },
            seguroSeleccionado() {
                var selec = this.seleccionado.idSeguro,
                    objeto = _.find(this.listaGeneral.seguro, function (o) {
                        return o.idSeguro == selec;
                    });
                this.seleccionado.naturaleza = objeto.naturaleza;
                this.seleccionado.regulacion = objeto.regulacion;
            },
            guardar() {
                if (this.$refs.form.validate()) {
                    this.insertarActualizar((this.seleccionado.idPoliza > "0") ? "U" : 'I');
                    // this.cerrarFormulario();
                    this.$refs.form.resetValidation();
                } else
                    mensajesAlerta(mensajeEstandar.corregirInformacion, 'I');
            },
        },
        props: ['cargar', 'seleccionado', 'tituloFormulario', 'listaGeneral', 'listaEstado', 'listaTipoPoliza'],
        inject: ['insertarActualizar', 'cerrarFormulario'],
    }
</script>

<style>
    .v-input__slot {
        /*border: 1px solid black;*/
        border-width: 1px !important;
    }
</style>